import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import categoriesReducer from './slices/categoriesSlice'
import catalogReducer from './slices/catalogSlice'
import productReducer from './slices/productSlice'
import checkoutReducer from './slices/checkoutSlice'
import sessionReducer from './slices/sessionSlice'
import wishlistReducer from './slices/wishlistSlice'
import viewedReducer from './slices/viewedSlice'
import userReducer from './slices/userSlice'
import shopsReducer from './slices/shopsSlice'
import cartReducer from './slices/cartSlice'
import pagesReducer from './slices/pagesSlice'
import searchReducer from './slices/searchSlice'
import profileReducer from './slices/profileSlice'
import currencyReducer from './slices/currencySlice'
import lookReducer from './slices/lookSlice'
import subscribeReducer from './slices/subscribeSlice'
import menuReducer from './slices/menuSlice'
import { Api } from '../api'

export function createStore(preloadedState, { baseUrl, storage, tokenGenerator, appBuildVersion, deviceType }) {
  const api = new Api(baseUrl, appBuildVersion, deviceType)

  const store = configureStore({
    reducer: {
      categories: categoriesReducer,
      catalog: catalogReducer,
      cart: cartReducer,
      product: productReducer,
      checkout: checkoutReducer,
      user: userReducer,
      session: sessionReducer,
      wishlist: wishlistReducer,
      viewed: viewedReducer,
      shops: shopsReducer,
      pages: pagesReducer,
      search: searchReducer,
      profile: profileReducer,
      currency: currencyReducer,
      look: lookReducer,
      subscribe: subscribeReducer,
      menu: menuReducer,
    },
    preloadedState,
    middleware: getDefaultMiddleware({
      thunk: {
        extraArgument: { api, storage, tokenGenerator },
      },
    }),
  })

  api.setStateReceivingFunction(store.getState)

  return store
}
